import {of} from 'rxjs';
import {map, catchError, switchMap} from 'rxjs/operators';
import {ofType} from 'redux-observable';
import Http from '../../http/http';
import AppSettings from '../../app.settings';
import Auth from '../../auth';

import * as ReportsActions from './reports.actions';

export const requestTableauReports = action$ =>
  action$.pipe(
    ofType(ReportsActions.CREATE_TABLEAU_USER_SUCCESS),
    switchMap(({payload}) =>
      Http.get(`/workbooks/${payload.username}`, {
        baseURL: AppSettings.BaseTableauProxyUrl
      }).pipe(
        map(data => ReportsActions.receiveTableauReports(data)),
        catchError(error => of(ReportsActions.requestTableauReportsFailed(error)))
      )
    )
  );

export const createTableauUser = action$ =>
  action$.pipe(
    ofType(ReportsActions.CREATE_TABLEAU_USER),
    switchMap(({payload}) =>
      Http.post(
        '/users',
        {username: payload.username, email: payload.email, securityContext: payload.context},
        {
          baseURL: AppSettings.BaseTableauProxyUrl
        }
      ).pipe(
        map(data => ReportsActions.createTableauUserSuccess(payload.username)),
        catchError(error => {
          if (error.status && error.status === 409) {
            return of(ReportsActions.createTableauUserSuccess(payload.username));
          }

          return of(ReportsActions.createTableauUserFailed(error));
        })
      )
    )
  );
